import React from 'react';
import cn from 'classnames';

import {getAssetUrl} from 'coreUtils/adapters/sdk';

import Icon from 'brandComponents/Icon';
import Image from 'brandComponents/Image';
import Typography from 'brandComponents/Typography';

import {IReturnInstructionsItemProps} from './IReturnInstructionsItem';

import styles from './ReturnInstructionsItem.module.scss';

const ReturnInstructionsItem = ({iconName, title, description}: IReturnInstructionsItemProps) => {
	const imgSrc = getAssetUrl(`static/img/ran/${iconName}.png`);

	return (
		<div className={cn(styles['return-instructions-item__container'], 'return-instructions-item__container')}>
			{imgSrc ? (
				<Image
					src={imgSrc}
					alt={iconName}
					showSkeleton={false}
					className={styles['return-instructions-item__image']}
				/>
			) : (
				<Icon name={iconName} width={20} height={20} />
			)}
			<Typography classNames={styles['return-instructions-item__title']} variant="h4">
				{title}
			</Typography>
			<Typography classNames={styles['return-instructions-item__description']} variant="p">
				{description}
			</Typography>
		</div>
	);
};

export default ReturnInstructionsItem;
